import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {DISP_MODE, EQUIPMENT_URLS, URL_PARAMS} from "../../../../constants/constants";

export interface AttachmentDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  attachmentId: string,
}

export function AttachmentDetailDialog(props: AttachmentDetailDialogProps) {
  const params = new URLSearchParams();
  params.append(URL_PARAMS.DISP_MODE, DISP_MODE.POPUP);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='ハンド詳細' src={`${EQUIPMENT_URLS.ATTACHMENT_DETAIL.URL}/${props.attachmentId}?${params.toString()}`}/>
  )
}
